export default __webpack_public_path__ + "static/media/omoda-logo-white.svg.dd0569f8.svg";